import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles((t: typeof theme) => ({
  toolbar: {
    marginBottom: '1rem',
  },

  tableWrapper: {
    '& th': {
      whiteSpace: 'normal !important',
      textAlign: 'center',
      lineHeight: '1.2',
      maxWidth: '200px',
    },
    '& th *': {
      whiteSpace: 'normal !important',
    },
    '& th span': {
      whiteSpace: 'normal !important',
      display: 'block',
    },
  },

  // react-tooltip has no default max-width, so a long info text renders as one
  // very wide line and gets positioned off-screen (e.g. the delta automation
  // header). Cap the width and let it wrap.
  infoTooltip: {
    maxWidth: '320px',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    textAlign: 'center',
    lineHeight: '1.3',
  },
}))
